import $ from "jquery";
window.$ = window.jQuery = $;

imageSliderSetUp();
setHash();
skillFill();
setActiveMenuItem();
setHeadline($);

//window.$('[data-jarallax-element]').jarallax_eleme({ speed: 0.2 });

window.$(window).on('load', function() {
    //imageSliderSetUp();
    moverImagen();
    setHash();
    window.$('.doc-loader').fadeOut();
});

window.$(window).on('resize', function() {
    skillFill();
    moverImagen()
    setActiveMenuItem();
});

window.$(window).on('scroll', function() {
    skillFill();
    moverImagen();
    setActiveMenuItem();
});

function moverImagen() {
    window.$(".jarallax-home").each(function() {
        let top_of_object = window.$(this).offset().top;
        let bottom_of_window = window.$(window).scrollTop() + window.$(window).height();
        if ((bottom_of_window + 200) > top_of_object) {
            let x = 400 + (top_of_object - bottom_of_window);
            x = x / 15
            window.$('.jarallax-home').css("transform", "translateX(" + x + "px)");
        }
    });
    window.$(".jarallax-title").each(function() {
        let top_of_object = window.$(this).offset().top;
        let bottom_of_window = window.$(window).scrollTop() + window.$(window).height();

        if ((bottom_of_window + 200) > top_of_object) {
            let x = -400 + (bottom_of_window - top_of_object);
            x = x / 10
            window.$('.jarallax-title').css("transform", "translateX(" + x + "px)");
        }
    });
    window.$(".jarallax-about").each(function() {
        var top_of_object = window.$(this).offset().top;
        var bottom_of_window = window.$(window).scrollTop() + window.$(window).height();
        if ((bottom_of_window - 70) >= top_of_object) {
            let num = top_of_object - bottom_of_window;
            num = num / 5;
            window.$('.jarallax-about').css("transform", "translateX(" + num + "px)");

        }
    });
    window.$(".jarallax-contact").each(function() {
        let top_of_object = window.$(this).offset().top;
        let bottom_of_window = window.$(window).scrollTop() + window.$(window).height();
        if ((bottom_of_window + 200) > top_of_object) {
            let x = -200 - (bottom_of_window - top_of_object);
            x = x / 2;
            window.$('.jarallax-contact').css("transform", "translateX(" + x + "px)");
        }
    });
    window.$(".jarallax-service").each(function() {
        let top_of_object = window.$(this).offset().top;
        let bottom_of_window = window.$(window).scrollTop() + window.$(window).height();
        if ((bottom_of_window + 200) > top_of_object) {
            let x = 400 + (top_of_object - bottom_of_window);
            window.$('.jarallax-service').css("transform", "translateX(" + x + "px)");
        }
    });
}

function setHash() {
    var hash = location.hash;
    if ((hash !== '') && (window.$(hash).length)) {
        window.$('html, body').animate({
            scrollTop: window.$(hash).offset().top
        }, 1);
        window.$('html, body').animate({
            scrollTop: window.$(hash).offset().top
        }, 1);
    } else {
        window.$(window).scrollTop(1);
        window.$(window).scrollTop(0);
    }
}

function skillFill() {
    if (window.$('.skill-fill')[0]) {
        window.$(".skill-fill:not(.animation-done").each(function() {
            var top_of_object = window.$(this).offset().top;
            var bottom_of_window = window.$(window).scrollTop() + window.$(window).height();
            if ((bottom_of_window - 70) > top_of_object) {
                window.$(this).width(window.$(this).data("fill"));
                //window.$(this).addClass('animation-done');
            }
        });
    }
}

function setActiveMenuItem() {
    var currentSection = null;
    var section_num = window.$('.page-wrapper .section.section-active').data("num");
    window.$('.section').each(function() {
        var element = window.$(this).attr('id');
        if (window.$('#' + element).is('*')) {
            if (window.$(window).scrollTop() >= window.$('#' + element).offset().top - 150) {
                currentSection = element;
            }
        }
    });
    window.$('.nav-menu ul li').removeClass('current').find('a[href*="#' + currentSection + '"]').parent().addClass('current');
    window.$('.page-wrapper .section').removeClass('section-active');
    window.$('#' + currentSection).addClass('section-active');
    if (section_num !== window.$('#' + currentSection).data("num")) {
        section_num = window.$('#' + currentSection).data("num");
        window.$('.current-num span').animate({
            "opacity": '0',
            "left": "-5px"
        }, 150, function() {
            window.$(this).text(section_num).animate({
                "opacity": '1',
                "left": "0"
            }, 150);
        });
    }
}

function imageSliderSetUp() {
    window.$(".image-slider").each(function() {
        var speed_value = $(this).data('speed');
        var auto_value = $(this).data('auto');
        var hover_pause = $(this).data('hover');
        if (auto_value === true) {

            window.$(this).owlCarousel({
                loop: true,
                autoHeight: true,
                smartSpeed: 1000,
                autoplay: auto_value,
                autoplayHoverPause: hover_pause,
                autoplayTimeout: speed_value,
                responsiveClass: true,
                items: 1
            });

            window.$(this).on('mouseleave', function() {
                window.$(this).trigger('stop.owl.autoplay');
                window.$(this).trigger('play.owl.autoplay', [auto_value]);
            });
        } else {

            window.$(this).owlCarousel({
                loop: true,
                autoHeight: true,
                smartSpeed: 1000,
                autoplay: false,
                responsiveClass: true,
                items: 1
            });

        }
    });
}

function setHeadline() {
    //set animation timing
    var animationDelay = 2500,
        //loading bar effect
        barAnimationDelay = 3800,
        barWaiting = barAnimationDelay - 3000, //3000 is the duration of the transition on the loading bar - set in the scss/css file
        //letters effect
        lettersDelay = 50,
        //type effect
        typeLettersDelay = 150,
        selectionDuration = 500,
        typeAnimationDelay = selectionDuration + 800,
        //clip effect
        revealDuration = 600,
        revealAnimationDelay = 1500;

    initHeadline();


    function initHeadline() {
        //insert <i> element for each letter of a changing word
        singleLetters($('.cd-headline.letters').find('b'));
        //initialise headline animation
        animateHeadline($('.cd-headline'));
    }

    function singleLetters($words) {
        $words.each(function() {
            var word = $(this),
                letters = word.text().split(''),
                selected = word.hasClass('is-visible');
            for (var i in letters) {
                if (word.parents('.rotate-2').length > 0) letters[i] = '<em>' + letters[i] + '</em>';
                letters[i] = (selected) ? '<i class="in">' + letters[i] + '</i>' : '<i>' + letters[i] + '</i>';
            }
            var newLetters = letters.join('');
            word.html(newLetters).css('opacity', 1);
        });
    }

    function animateHeadline($headlines) {
        var duration = animationDelay;
        $headlines.each(function() {
            var headline = $(this);

            if (headline.hasClass('loading-bar')) {
                duration = barAnimationDelay;
                setTimeout(function() {
                    headline.find('.cd-words-wrapper').addClass('is-loading')
                }, barWaiting);
            } else if (headline.hasClass('clip')) {
                var spanWrapper = headline.find('.cd-words-wrapper'),
                    newWidth = spanWrapper.width() + 10
                spanWrapper.css('width', newWidth);
            } else if (!headline.hasClass('type')) {
                //assign to .cd-words-wrapper the width of its longest word
                var words = headline.find('.cd-words-wrapper b'),
                    width = 0;
                words.each(function() {
                    var wordWidth = $(this).width();
                    if (wordWidth > width) width = wordWidth;
                });
                headline.find('.cd-words-wrapper').css('width', width);
            }

            //trigger animation
            setTimeout(function() {
                hideWord(headline.find('.is-visible').eq(0))
            }, duration);
        });
    }

    function hideWord($word) {
        var nextWord = takeNext($word);

        if ($word.parents('.cd-headline').hasClass('type')) {
            var parentSpan = $word.parent('.cd-words-wrapper');
            parentSpan.addClass('selected').removeClass('waiting');
            setTimeout(function() {
                parentSpan.removeClass('selected');
                $word.removeClass('is-visible').addClass('is-hidden').children('i').removeClass('in').addClass('out');
            }, selectionDuration);
            setTimeout(function() {
                showWord(nextWord, typeLettersDelay)
            }, typeAnimationDelay);

        } else if ($word.parents('.cd-headline').hasClass('letters')) {
            var bool = ($word.children('i').length >= nextWord.children('i').length) ? true : false;
            hideLetter($word.find('i').eq(0), $word, bool, lettersDelay);
            showLetter(nextWord.find('i').eq(0), nextWord, bool, lettersDelay);

        } else if ($word.parents('.cd-headline').hasClass('clip')) {
            $word.parents('.cd-words-wrapper').animate({
                width: '2px'
            }, revealDuration, function() {
                switchWord($word, nextWord);
                showWord(nextWord);
            });

        } else if ($word.parents('.cd-headline').hasClass('loading-bar')) {
            $word.parents('.cd-words-wrapper').removeClass('is-loading');
            switchWord($word, nextWord);
            setTimeout(function() {
                hideWord(nextWord)
            }, barAnimationDelay);
            setTimeout(function() {
                $word.parents('.cd-words-wrapper').addClass('is-loading')
            }, barWaiting);

        } else {
            switchWord($word, nextWord);
            setTimeout(function() {
                hideWord(nextWord)
            }, animationDelay);
        }
    }

    function showWord($word, $duration) {
        if ($word.parents('.cd-headline').hasClass('type')) {
            showLetter($word.find('i').eq(0), $word, false, $duration);
            $word.addClass('is-visible').removeClass('is-hidden');

        } else if ($word.parents('.cd-headline').hasClass('clip')) {
            $word.parents('.cd-words-wrapper').animate({
                'width': $word.width() + 10
            }, revealDuration, function() {
                setTimeout(function() {
                    hideWord($word)
                }, revealAnimationDelay);
            });
        }
    }

    function hideLetter($letter, $word, $bool, $duration) {
        $letter.removeClass('in').addClass('out');

        if (!$letter.is(':last-child')) {
            setTimeout(function() {
                hideLetter($letter.next(), $word, $bool, $duration);
            }, $duration);
        } else if ($bool) {
            setTimeout(function() {
                hideWord(takeNext($word))
            }, animationDelay);
        }

        if ($letter.is(':last-child') && $('html').hasClass('no-csstransitions')) {
            var nextWord = takeNext($word);
            switchWord($word, nextWord);
        }
    }

    function showLetter($letter, $word, $bool, $duration) {
        $letter.addClass('in').removeClass('out');

        if (!$letter.is(':last-child')) {
            setTimeout(function() {
                showLetter($letter.next(), $word, $bool, $duration);
            }, $duration);
        } else {
            if ($word.parents('.cd-headline').hasClass('type')) {
                setTimeout(function() {
                    $word.parents('.cd-words-wrapper').addClass('waiting');
                }, 200);
            }
            if (!$bool) {
                setTimeout(function() {
                    hideWord($word)
                }, animationDelay)
            }
        }
    }

    function takeNext($word) {
        return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
    }
    /*
    function takePrev($word) {
      return (!$word.is(':first-child')) ? $word.prev() : $word.parent().children().last();
    }*/

    function switchWord($oldWord, $newWord) {
        $oldWord.removeClass('is-visible').addClass('is-hidden');
        $newWord.removeClass('is-hidden').addClass('is-visible');
    }
}